import { Component, Input, OnChanges, OnInit, Output, AfterViewInit, ɵConsole } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Platform } from '@ionic/angular';
import { HttpCustomerService } from '../../../../service/httpcustomer.service';
import { MapclientServiceService} from '../../../../service/mapclient.service.service';
import { BaseModal } from '../../../../model/base';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { CommonService} from '../../../../service/common.service';
import { MessageclientService } from '../../../../service/messageclient.service';
import { DatePipe} from '@angular/common';
declare var app;
@Component({
  selector: 'app-mz-head-visit',
  templateUrl: './mz-head-visit.component.html',
  styleUrls: ['./mz-head-visit.component.scss']
})
export class MzHeadVisitComponent extends GridBaseCase {
  juli:any = 0;
  constructor(
    private http: HttpCustomerService,
    private platform: Platform,
    private router: Router,
    private actionRouter: ActivatedRoute,
    private base:BaseModal,
    private msg:MessageclientService,
    private com:CommonService,
    private map:MapclientServiceService
  ) { super(); }
LoadData(){
  const that = this;
  const PageName = that.actionRouter.snapshot.paramMap.get("ConfigName");
  let  id:any =null;
    if(that.actionRouter.snapshot.paramMap.get('id')){
      id = that.actionRouter.snapshot.paramMap.get('id').split('&')[0];
    }
  let body = new WebParameterContext();
  body.ConfigName = that.config[0].selectItemList.gridViewConfigName;
  body.OpType = "query";
  body.ConfigType = "view";
  body.Client.PageName = PageName;
  body.Client.ApiType = "Content";
  body.Client.Name = that.ConfigName;
  body.Client.Type = "gET";
  body.Client.ClientType = 2;
  body.CurrentDepartment = that.base.Department;
  if (that.platform.is("android")) {
    body.Client.ClientType = 0;
  } else if (that.platform.is("ios")) {
    body.Client.ClientType = 1;
  }
  body.ID = id;
  body.RequestBody = JSON.stringify({"a_ID":id});

  that.msg.Loading("数据提交中...").then(load => {
    that.http.post(app.DEFAULTURL, body).then(
      data => {
        if (data.ResponseMessage.Success) {
          // console.log(data);
          let tbstroe = {};
              tbstroe["ID"]=data.Status.Datas[0].a_FK_Object_ID;
              tbstroe["address"]=data.Status.Datas[0].a_Address;
              tbstroe["name"]=data.Status.Datas[0].a_ObjectName;
              localStorage.setItem("tbinhome",JSON.stringify({"ID":id}));
              console.log();
              localStorage.setItem("tbstore",JSON.stringify(tbstroe));//门店ID
          load.dismiss(data.Status.Datas[0]);
          that.config[0].selectItemList.selectItem.forEach((items,index)=>{
            if(items.bindingField && items.field){
              that.formObject[items.bindingField] = {"text":items.text,"value":data.Status.Datas[0][items.field]};
            }
           
          });
          if(that.formObject["indate"].value){
            localStorage.setItem("pgindata",that.formObject["indate"].value);
          }else{
            localStorage.removeItem("pgindata");
          }
         if(that.formObject["ondate"].value){//下班时间
           localStorage.setItem("pgondate",that.formObject["ondate"].value);
         }else{
          localStorage.removeItem("pgondate");
         }
          console.log("100");
          //判断是否协防
          // if( that.formObject["isvisit"]){
          //   if(that.formObject["isvisit"].value){
          //   if(document.getElementsByName("app_TBXiaShuDianPingXML_B190311140502865_like")){//下属点评
          //     document.getElementsByName("app_TBXiaShuDianPingXML_B190311140502865_like")[0].style.display="block";
          //   }
          //   }else{
          //     if(document.getElementsByName("app_TBXiaShuDianPingXML_B190311140502865_like")){
          //       document.getElementsByName("app_TBXiaShuDianPingXML_B190311140502865_like")[0].style.display="none";
          //     }
          //   }
          // }
          //坐标距离计算
          
          let lng = that.formObject["inLng"].value;
          let lat = that.formObject["inlat"].value;
          let elng = that.formObject["lng"].value;
          let elat = that.formObject["lat"].value;
          // that.map.Geolocation("").then((data=>{

          // }));
          let counnum:number = that.com.Dist(elng,elat,lng,lat);
          that.juli=0;
          const customer:number = app.LOCATIONLENGTH;
          if(counnum>customer){
            that.juli=counnum.toFixed(2);
          }
          // that.formObject["count"]=counnum.toFixed(2);
        } else {
          load.dismiss();
          that.msg.Show(data.ResponseMessage.ErrorMessage);
        }
      }
    ).catch(error => {
      load.dismiss();
      that.msg.Alert(error);
    });
    load.present();
  })

}
outHome(){
  console.log(this.formObject);
  const that = this;
  //先判断是否必填项未完成
  const PageName = that.actionRouter.snapshot.paramMap.get("ConfigName");
  // that.com.setBadge("buttons","main_link_2","leav")
  if(that.formObject["state"].value!="S003"){
    if(!that.com.getBadge(PageName)){
      that.msg.Alert("您有未完成的项,不可离店");
    }else{
    //获取进店门店坐标
    let getId = this.actionRouter.snapshot.paramMap.get("id");
    let obj={};
    // obj["inpostion"]={"lng": this.formObject["inLng"].value,"lat":this.formObject["inlat"].value};
    // obj["mendianpostion"]={"lng": this.formObject["lng"].value,"lat":this.formObject["lat"].value};
    // let getId = this.actionRouter.snapshot.paramMap.get("id")+"&"+escape(JSON.stringify(obj));
    // console.log(getId);
    let datepie:DatePipe =new DatePipe("en-US");
        obj["a_ID"]=getId;
        obj["a_EndDate"]=datepie.transform(new Date(),"yyyy-MM-dd HH:mm:ss");
        // alert("要离店了");
        that.msg.Confirm("确认离店？").then((data)=>{
          if(data){
            localStorage.setItem("visitStoreInfo",JSON.stringify({
              id:that.formObject["ID"].value,
              address:that.formObject["address"].value,
              name:that.formObject["name"].value
            }));
            this.com.Go("/tabs/contact/VisitOut/add/"+getId);
            that.com.setHistoryUrl(false);
            // that.HomeOut(obj);
          }
        })
    // this.router.navigate(["/tabs/contact/VisitOut/add/"+getId]);
   }
  }else{
    this.msg.Show("已离店,不可继续操作");
  }
  // this.router.navigate(["/tabs/contact/VisitOut/add/"+this.actionRouter.snapshot.paramMap.get("id")]);
}
HomeOut(outBody:any){
  const that = this;
  // that.LoadData1();//
  // console.log("1008611");
  const pageName = that.actionRouter.snapshot.paramMap.get('ConfigName');
  const types = that.actionRouter.snapshot.paramMap.get('type');
  let  id:any =null;
    let body: WebParameterContext = new WebParameterContext();
    body.ConfigName ="TBVisitPlanConfigXML";
    body.OpType = "edite";
    body.ConfigType = "form";
    body.Client.PageName = pageName;
    body.SpecialParameter = "leavehome";//进店
    body.RequestBody = JSON.stringify(outBody);
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        // that.msg.Alert("离店成功");
        localStorage.removeItem("badge_"+that.com.GetAccount.Id);
        that.formObject["ondate"].value=outBody.a_EndDate;
        if(that.formObject["ondate"].value){//下班时间
          localStorage.setItem("pgondate",that.formObject["ondate"].value);
        }else{
         localStorage.removeItem("pgondate");
        }
        this.com.Go("/tabs/contact/HomeSFA/type/"+that.com.getNowDatetime);
      } else {
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
    }).catch(error => {
      that.msg.Alert(error.ResponseMessage.ErrorMessage);
    });
  
}


}

